import { gql } from '@apollo/client'
import employeeDisplayShortInfoFragment from '../../employee/fragments/employeeDisplayShortInfo.fragment'

export default gql`
  fragment Kudos on KudosDTO {
    id
    employeeId
    type
    authorId
    description
    createdDate
    deletable
    employee {
      ...EmployeeDisplayShortInfo
    }
    author {
      ...EmployeeDisplayShortInfo
    }
  }
  ${employeeDisplayShortInfoFragment}
`
